<template>
  <div>
    <div class="d-flex align-center">
      <img :style="{
             filter: integration.state == 'connected' ? '' : 'grayscale(100%)',
             opacity: ['loading'].indexOf(integration.state) > -1 ? .5 : 1,
           }"
           src="../../img/integrations/calendar.png" alt="calendar" style="width: 40px">
      <b class="ml-2">{{ $t('INTEGRATIONS.WEBCALENDAR.TITLE') }}</b>
    </div>
    <div class="mt-4 mb-2">
      <div v-if="integration.state == 'inactive'">
        <v-btn color="primary" rounded @click="activateLink()">
          <v-icon class="mr-2">far fa-plus</v-icon> {{ $t('INTEGRATIONS.WEBCALENDAR.ACTIVATE') }}
        </v-btn>
      </div>
      <div v-if="integration.state == 'loading'">
        <v-icon color="primary">far fa-spinner fa-spin fa-2x fa-fw</v-icon>
      </div>
      <div v-if="integration.state == 'connected'" class="d-flex align-center">
        <v-icon color="successgreen">fa fa-check</v-icon>
        <span class="ml-2">{{ $t('INTEGRATIONS.WEBCALENDAR.LINK_ACTIVE') }}</span>
        <v-btn color="errorred" rounded variant="outlined" class="ml-4" @click="deleteLink()">
          {{ $t('INTEGRATIONS.WEBCALENDAR.RESET_LINK') }}
        </v-btn>
      </div>
      <div v-if="integration.state == 'error'" class="d-flex align-center">
        <v-icon color="errorred">far fa-exclamation-triangle</v-icon>
        <span class="ml-2" style="line-height: 1.2;">{{ integration.error }}</span>
      </div>
    </div>
    <div v-if="webcalToken" class="mb-2">
      <!-- INPUT LINK -->
      <v-text-field v-if="linkWebCalendar" id="inputWebCalendarLink" :model-value="linkWebCalendar" variant="solo" readonly @focus="$event.target.select()">
        <template #append-inner>
          <v-tooltip location="bottom">
            <template #activator="{ props }">
              <v-btn-icon size="small" v-bind="props" @click="copyToClipboard()">
                <v-icon v-show="! copyingToClipboard.success && ! copyingToClipboard.error" size="large" color="primary">far fa-clipboard</v-icon>
                <v-icon v-show="copyingToClipboard.success" size="large" color="successgreen">far fa-check</v-icon>
                <v-icon v-show="copyingToClipboard.error" size="large" color="errorred">far fa-exclamation-triangle</v-icon>
              </v-btn-icon>
            </template>
            {{ copyingToClipboard.error ? $t('SHARE.COPY_FAILED') : $t('SHARE.COPY_CLIPBOARD') }}
          </v-tooltip>
        </template>
      </v-text-field>
      <!-- INPUT LINK -->
    </div>
    <div class="pt-2">
      {{ $t('INTEGRATIONS.WEBCALENDAR.BENEFITS') }}
      <premium-section feature="webcalendar" class="mt-2 strong"></premium-section>
    </div>
  </div>
</template>

<script>
  import useUiMsgboxStore from '@/stores/ui/msgbox';
  import useUsersStore from '@/stores/users';
  import useUsersAccessRightStore from '@/stores/users/accessRight';

  export default {
    data() {
      return {
        integration: {
          state: 'loading',
          error: null,
        },
        copyingToClipboard: { success: false, error: false },
        webcalToken: null,
        uiMsgboxStore: useUiMsgboxStore(),
        usersStore: useUsersStore(),
        usersAccessRightStore: useUsersAccessRightStore(),
      };
    },
    computed: {
      linkWebCalendar() {
        if (! this.webcalToken) return '';
        const subdomain = window.location.hostname.replace(/(.*)\.bubbleplan\.net/i, '$1');
        let linkWebCalendar = `webcal://api.bubbleplan.net/v1/webcal/calendar/${this.webcalToken}`;
        if (subdomain != window.location.hostname && subdomain != 'app') linkWebCalendar += `?subdomain=${subdomain}`;
        return linkWebCalendar;
      },
      isPremium() { return this.usersAccessRightStore.isPremium; },
    },
    created() {
      this.usersStore.userPromise.then(() => {
        if (this.isPremium) {
          this.loadIntegration();
        }
      });
    },
    methods: {
      copyToClipboard() {
        const input = document.getElementById('inputWebCalendarLink');
        this.copyingToClipboard = { success: false, error: false };
        try {
          input.select();
          document.execCommand('selectAll');
          document.execCommand('copy');
          this.copyingToClipboard.success = true;
          setTimeout(() => { this.copyingToClipboard.success = false; }, 3000);
        } catch (e) {
          this.copyingToClipboard.error = true;
        }
      },
      loadIntegration() {
        window.apiSrv.call('webcal/token').then((response) => {
          this.webcalToken = response.data.token;
          this.integration = {
            state: this.webcalToken ? 'connected' : 'inactive',
          };
        }).catch((error) => {
          this.integration = {
            state: 'error',
            error,
          };
        });
      },
      activateLink() {
        this.integration.state = 'loading';
        window.apiSrv.call('webcal/token', 'store').then((response) => {
          this.webcalToken = response.data.token;
          this.integration = {
            state: this.webcalToken ? 'connected' : 'inactive',
          };
        }).catch((error) => {
          this.integration = {
            state: 'error',
            error,
          };
        });
      },
      deleteLink() {
        this.uiMsgboxStore.open({
          title: this.$t('INTEGRATIONS.WEBCALENDAR.RESET_LINK_TITLE'),
          body: this.$t('INTEGRATIONS.WEBCALENDAR.RESET_LINK_BODY'),
          buttons: { ok: this.$t('INTEGRATIONS.WEBCALENDAR.RESET_LINK'), cancel: this.$t('GLOBAL.CANCEL') },
        }).then(() => {
          this.integration.state = 'loading';
          window.apiSrv.call('webcal', 'destroy', 'token').then(() => {
            this.webcalToken = '';
            this.integration = {
              state: this.webcalToken ? 'connected' : 'inactive',
            };
          }).catch((error) => {
            this.integration = {
              state: 'error',
              error,
            };
          });
        }).catch(() => {});
      },
    },
  };
</script>
